import { Station } from '@mi-front/core';

export function useLowerthirdEnabled(station: Station) {
  return Boolean(
    station.featuresConfig?.videoAnalysis?.enabled &&
      station.featuresConfig?.videoAnalysis?.lowerThird?.enabled,
  );
}
